// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/message_content.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { GetStreamOldResponse } from "../../../stream/v1/stream_pb.js";

/**
 * @generated from enum social.chat.entity.v2.SharedContentType
 */
export const SharedContentType = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.SharedContentType",
  [
    {no: 0, name: "SHARED_CONTENT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SHARED_CONTENT_TYPE_STREAM", localName: "STREAM"},
    {no: 2, name: "SHARED_CONTENT_TYPE_GROUP_INVITATION", localName: "GROUP_INVITATION"},
    {no: 3, name: "SHARED_CONTENT_TYPE_SHARETRADE", localName: "SHARETRADE"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.Attachment
 */
export const Attachment = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.Attachment",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "size", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.SharedContentInternal
 */
export const SharedContentInternal = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.SharedContentInternal",
  () => [
    { no: 1, name: "source_type", kind: "enum", T: proto3.getEnumType(SharedContentInternal_SourceType) },
    { no: 2, name: "source_data", kind: "message", T: SharedContentInternal_SourceData },
  ],
);

/**
 * @generated from enum social.chat.entity.v2.SharedContentInternal.SourceType
 */
export const SharedContentInternal_SourceType = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.SharedContentInternal.SourceType",
  [
    {no: 0, name: "SOURCE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SOURCE_TYPE_REFERENCE", localName: "REFERENCE"},
    {no: 2, name: "SOURCE_TYPE_PAYLOAD", localName: "PAYLOAD"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.SharedContentInternal.SourceData
 */
export const SharedContentInternal_SourceData = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.SharedContentInternal.SourceData",
  () => [
    { no: 1, name: "reference", kind: "message", T: SharedContent, oneof: "source" },
    { no: 2, name: "payload", kind: "message", T: SharedContentPayload, oneof: "source" },
  ],
  {localName: "SharedContentInternal_SourceData"},
);

/**
 * @generated from message social.chat.entity.v2.SharedContent
 */
export const SharedContent = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.SharedContent",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(SharedContentType) },
    { no: 2, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.SharedContentPayload
 */
export const SharedContentPayload = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.SharedContentPayload",
  () => [
    { no: 1, name: "payload", kind: "message", T: SharedContentPayload_Payload },
  ],
);

/**
 * @generated from enum social.chat.entity.v2.SharedContentPayload.Type
 */
export const SharedContentPayload_Type = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.SharedContentPayload.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_SHARETRADE", localName: "SHARETRADE"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.SharedContentPayload.Payload
 */
export const SharedContentPayload_Payload = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.SharedContentPayload.Payload",
  () => [
    { no: 1, name: "sharetrade", kind: "message", T: ShareTradeInfo, oneof: "data" },
  ],
  {localName: "SharedContentPayload_Payload"},
);

/**
 * @generated from message social.chat.entity.v2.SharedContentPreview
 */
export const SharedContentPreview = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.SharedContentPreview",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(SharedContentType) },
    { no: 2, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "preview", kind: "message", T: SharedContentPreview_Preview },
  ],
);

/**
 * @generated from message social.chat.entity.v2.SharedContentPreview.Preview
 */
export const SharedContentPreview_Preview = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.SharedContentPreview.Preview",
  () => [
    { no: 1, name: "stream", kind: "message", T: GetStreamOldResponse, oneof: "data" },
    { no: 2, name: "invitation", kind: "message", T: InvitationContentPreview, oneof: "data" },
    { no: 3, name: "sharetrade", kind: "message", T: ShareTradeInfo, oneof: "data" },
  ],
  {localName: "SharedContentPreview_Preview"},
);

/**
 * @generated from message social.chat.entity.v2.InvitationContentPreview
 */
export const InvitationContentPreview = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.InvitationContentPreview",
  () => [
    { no: 1, name: "invitation_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "room_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.ShareTradeInfo
 */
export const ShareTradeInfo = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.ShareTradeInfo",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_type", kind: "enum", T: proto3.getEnumType(ShareTradeInfo_OrderType) },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(ShareTradeInfo_OrderStatus) },
    { no: 5, name: "updated_status", kind: "enum", T: proto3.getEnumType(ShareTradeInfo_UpdatedStatus) },
    { no: 6, name: "price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "updated_price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "parent_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "order_time", kind: "message", T: Timestamp },
    { no: 10, name: "label", kind: "enum", T: proto3.getEnumType(ShareTradeInfo_Label) },
    { no: 11, name: "is_show_value", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "qty", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "updated_qty", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "total_investment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "is_amend_lot", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from enum social.chat.entity.v2.ShareTradeInfo.OrderType
 */
export const ShareTradeInfo_OrderType = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.ShareTradeInfo.OrderType",
  [
    {no: 0, name: "ORDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_TYPE_BUY", localName: "BUY"},
    {no: 2, name: "ORDER_TYPE_SELL", localName: "SELL"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.ShareTradeInfo.OrderStatus
 */
export const ShareTradeInfo_OrderStatus = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.ShareTradeInfo.OrderStatus",
  [
    {no: 0, name: "ORDER_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ORDER_STATUS_OPEN", localName: "OPEN"},
    {no: 2, name: "ORDER_STATUS_AMEND", localName: "AMEND"},
    {no: 3, name: "ORDER_STATUS_CANCEL", localName: "CANCEL"},
    {no: 4, name: "ORDER_STATUS_MATCH", localName: "MATCH"},
    {no: 5, name: "ORDER_STATUS_PARTIAL_MATCH", localName: "PARTIAL_MATCH"},
    {no: 6, name: "ORDER_STATUS_PENDING", localName: "PENDING"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.ShareTradeInfo.UpdatedStatus
 */
export const ShareTradeInfo_UpdatedStatus = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.ShareTradeInfo.UpdatedStatus",
  [
    {no: 0, name: "UPDATED_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "UPDATED_STATUS_AMENDED", localName: "AMENDED"},
    {no: 2, name: "UPDATED_STATUS_CANCELLED", localName: "CANCELLED"},
  ],
);

/**
 * @generated from enum social.chat.entity.v2.ShareTradeInfo.Label
 */
export const ShareTradeInfo_Label = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.ShareTradeInfo.Label",
  [
    {no: 0, name: "LABEL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "LABEL_DAY_TRADE", localName: "DAY_TRADE"},
    {no: 2, name: "LABEL_SPLIT_ORDER", localName: "SPLIT_ORDER"},
  ],
);

